/**
 * The free length cap, on every provider: a free user's video is at most FREE_MAX_DURATION_SEC.
 * The backend enforces it; this mirrors it in the UI.
 */

export const FREE_MAX_DURATION_SEC = 30;

/** Seconds as m:ss (90 → "1:30"). */
export function formatLength(sec: number): string {
  const total = Math.max(0, Math.round(Number(sec) || 0));
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, '0')}`;
}

/** The auto-mode length choices: only the cap when capped, else every step. */
export function autoDurationSteps(steps: number[], capped: boolean): number[] {
  return capped ? [FREE_MAX_DURATION_SEC] : steps;
}

/** A requested length clamped to the cap when capped. */
export function capDuration(sec: number, capped: boolean): number {
  return capped ? Math.min(sec, FREE_MAX_DURATION_SEC) : sec;
}

/** Where "Plan the full length" works: the latest plan, either before any film and
 *  with nothing rendering (a re-plan) or once the film is delivered (a change request). */
export function canPlanFullLength(o: { isLatestPlan: boolean; hasVideo: boolean; rendering: boolean; completed: boolean; failed?: boolean }): boolean {
  if (!o.isLatestPlan || o.rendering || o.failed) return false;
  return !o.hasVideo || o.completed;
}
